import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

export interface RespondentAuditEvent {
  respondentAuditId: number;
  referenceId?: string | null;
  importId?: number | null;
  subjectUserId?: number | null;
  enrollmentId?: number | null;
  flowStep: string;
  eventLabel: string;
  eventType: string;
  outcome: string;
  actorUserId?: number | null;
  initiatedBy: string;
  initiatedByName?: string | null;
  metadataJson?: string | null;
  createdAt: string;
}

export interface RespondentAuditFlowResponse {
  referenceId?: string | null;
  importId?: number | null;
  subjectUserId?: number | null;
  respondentName?: string | null;
  totalCount: number;
  events: RespondentAuditEvent[];
}

export interface CreateRespondentAuditEventRequest {
  referenceId?: string;
  importId?: number | null;
  subjectUserId?: number | null;
  enrollmentId?: number | null;
  flowStep: string;
  eventLabel: string;
  eventType: string;
  outcome: "success" | "failed" | "submit";
  initiatedBy: "student" | "admin" | "system";
  initiatedByName?: string | null;
  metadataJson?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class RespondentAuditService {
  constructor(private api: ApiService) {}

  getFlow(params: {
    referenceId?: string;
    subjectUserId?: number;
    importId?: number;
  }): Observable<RespondentAuditFlowResponse> {
    let httpParams = new HttpParams();
    if (params.referenceId?.trim()) {
      httpParams = httpParams.set("referenceId", params.referenceId.trim());
    }
    if (params.importId && params.importId > 0) {
      httpParams = httpParams.set("importId", String(params.importId));
    }
    if (params.subjectUserId) {
      httpParams = httpParams.set("subjectUserId", String(params.subjectUserId));
    }
    return this.api.getPath<RespondentAuditFlowResponse>("respondentaudit/flow", {
      params: httpParams,
    });
  }

  createEvent(request: CreateRespondentAuditEventRequest): Observable<{ success?: boolean; message?: string }> {
    return this.api.postPath<{ success?: boolean; message?: string }>(
      "respondentaudit/events",
      request,
    );
  }
}
